module.exports = __webpack_public_path__ + "static/HeroSketch-Carousel-mobile-80d2f9b83d5ca1c549f8e0d7b30e631e.jpg";